<template>
    <div id="snapshot">
        <div class="header">
            <div class="logo">
                <v-progress-circular
                    v-if="isLoading"
                    :size="40"
                    color="rgba(255, 255, 255)"
                    indeterminate
                ></v-progress-circular>
                <router-link to="/" class="dashboard no-underline" v-if="!isLoading">
                    <img :src="sharedEvent && sharedEvent.brand && sharedEvent.brand.navigationUri ? sharedEvent.brand.navigationUri : defaultNavigationUri" alt="" class="responsive" />
                    <span v-if="sharedEvent && sharedEvent.brand && sharedEvent.brand.showPoweredBy" class="powered-by"> Powered by Spillard Live</span>
                </router-link>
            </div>
            <div class="login-button">
                <router-link to="/" class="no-underline">
                    <sp-button sp-class="gray" icon="user" text="Sign in"></sp-button>
                </router-link>
            </div>
        </div>

        <div class="view" v-if="sharedEvent && sharedEvent.event">
            <div class="shared-event__info">
                <h1 class="shared-event__title">Event report: <span>{{ sharedEvent.name }}</span></h1>
                <p class="shared-event__desc">Description: <span>{{ sharedEvent.description }}</span></p>
            </div>
            <v-card>
                <v-card-title>
                    <v-card-title>
                        <div class="icon-slot">
                            <icon class="logout-icon" icon="video" :height="20" :width="20" />
                        </div>
                        <div class="reg-number">
                            Reg Number: <span class="text-bold">{{
                                sharedEvent.event.driverName || 'Any'
                            }} / {{ this.sharedEvent.event.vrn || 'Unknown' }}</span>
                        </div>
                        <div class="make">
                            Organization: <span class="text-bold">{{ sharedEvent.event.organizationName }}</span>
                        </div>
                        <div class="make">
                            Fleet: <span class="text-bold">{{ sharedEvent.event.fleetName }}</span>
                        </div>
                        <div class="make">
                            Hardware Id: <span class="text-bold">{{ sharedEvent.event.hardwareId }}</span>
                        </div>
                    </v-card-title>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap justify-space-around grid-list-md class="details">
                        <v-flex md12 lg4>
                            <div class="box">
                                <div class="title">Event details</div>
                                <div class="content">
                                    <v-layout row>
                                        <v-flex xs4>
                                            {{ this.sharedEvent.event.eventTypes.length > 1 ? 'Types' : 'Type' }}:
                                        </v-flex>
                                        <v-flex xs8 class="text-bold">
                                            {{ eventTypes }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs4>
                                            {{
                                                this.sharedEvent.event.eventCategories.length > 1 ? 'Categories' : 'Category'
                                            }}:
                                        </v-flex>
                                        <v-flex xs8 class="text-bold">
                                            {{ eventCategories }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs4>
                                            Classification:
                                        </v-flex>
                                        <v-flex xs8 class="text-bold">
                                            {{ sharedEvent.event.eventClassification }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs4>
                                            Event date:
                                        </v-flex>
                                        <v-flex xs8 class="text-bold">
                                            {{ dateFormat(sharedEvent.event.triggerOn) }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs4>
                                            Event location:
                                        </v-flex>
                                        <v-flex xs8 class="text-bold">
                                            {{ sharedEvent.event.address ? sharedEvent.event.address.label : 'Unknown' }}
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex md6 lg4 v-if="isGSensorGraph">
                            <div class="box">
                                <div class="title">Gsensor graph</div>
                                <div class="content">
                                    <GChart
                                        type="LineChart"
                                        :data="gSensorChartData"
                                        :options="gSensorChartOptions"
                                        style="height: 300px; width: 100%;"
                                    >
                                    </GChart>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex md6 lg4 v-if="isSpeedingGraph">
                            <div class="box">
                                <div class="title">Speed graph</div>
                                <div class="content">
                                    <GChart
                                        type="LineChart"
                                        :data="speedChartData"
                                        :options="speedChartOptions"
                                        style="height: 300px; width: 100% !important;"
                                    >
                                    </GChart>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-space-around grid-list-md class="visualisation">
                        <v-flex xs8 class="map">
                            <div class="box">
                                <div class="title">Event location</div>
                                <div class="content no-padding">
                                    <here-map v-if="isMap" map-name="eventDialogMap" parent="shared"
                                              :lat="sharedEvent.event.locations[0].lat"
                                              :lng="sharedEvent.event.locations[0].lng"
                                              :zoom="14"
                                    >
                                        <here-info-bubble
                                            name="event-dialog-bubble"
                                            :lat="sharedEvent.event.locations[0].lat"
                                            :lng="sharedEvent.event.locations[0].lng"
                                            :component="vehicleInfoBubble"
                                            :data="{
                                                        status: 'sleep',
                                                        registrationNumber: sharedEvent.event.vrn || 'Unknown',
                                                        driverName: sharedEvent.event.driverName || 'Unknown',
                                                        hardwareId: sharedEvent.event.hardwareId,
                                                        latitude: sharedEvent.event.locations[0].lat,
                                                        longitude: sharedEvent.event.locations[0].lng,
                                                    }"
                                        >
                                            <here-marker
                                                auto-tap
                                                :lat="sharedEvent.event.locations[0].lat"
                                                :lng="sharedEvent.event.locations[0].lng"
                                                :icon="{
                                                            bitmap: carMarker,
                                                            options: { anchor: { x:0, y: 0 } }
                                                        }">

                                            </here-marker>
                                        </here-info-bubble>
                                    </here-map>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs4 class="snapshots">
                            <div class="media no-margin">
                                <div class="title">Media</div>
                                <div class="content no-padding">
                                    <v-carousel
                                        v-if="sharedEvent.media.items && sharedEvent.media.items.length > 0"
                                        :cycle="false"
                                        :height="329"
                                        :class="{
                                            'one-item-carousel': sharedEvent.media.items.length === 1,
                                            'many-media-items': sharedEvent.media.items.length > 12,
                                        }"
                                    >
                                        <v-carousel-item v-for="item in sharedEvent.media.items" :key="item.id">
                                            <div class="carousel-item-wrapper">
                                                <video-m-p-e-g
                                                    v-if="item.mimeType === 'video/mp4'"
                                                    :url="item.uri"
                                                    :tracks="item.overlayUris"
                                                    :can-download-video="false"
                                                ></video-m-p-e-g>
                                                <img v-else :src="item.uri" alt="">
                                            </div>
                                        </v-carousel-item>
                                    </v-carousel>
                                    <div class="no-media" v-else>
                                        No media available for this snapshot, try again later
                                    </div>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </div>
        <div class="view" v-if="snapshotPackageNotFound">
            <h1>Snapshot report not exist</h1>
        </div>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import { formatDate, splitCamelCase } from '@/helpers/Utils'
import { DeviceEventSharedApi } from '@/api'
import moment from 'moment'
import HereMap from '@/components/maps/here/HereMap'
import HereInfoBubble from '@/components/maps/here/components/HereInfoBubble'
import HereMarker from '@/components/maps/here/components/HereMarker'
import VehicleInfoBubble from '@/components/atoms/VehicleInfoBubble'
import VideoMPEG from '@/components/atoms/VideoMPEG'
import logo from '@/assets/images/logo.svg'
import Icon from '@/components/atoms/Icon'

const deviceEventSharedApi = new DeviceEventSharedApi()

export default {
    name: 'SharedEvent',
    async mounted () {
        this.uri = this.$route.params.sharedUri

        await this.getSharedEvent()
        this.isLoading = false
        this.updateFavicon()
        await this.drawCharts()
    },
    components: {
        VideoMPEG,
        HereMap,
        HereInfoBubble,
        HereMarker,
        SpButton,
        Icon
    },
    data () {
        return {
            uri: null,
            isLoading: true,
            defaultNavigationUri: logo,
            sharedEvent: null,
            snapshotPackageNotFound: false,
            gSensorChartData: [],
            gSensorChartOptions: {
                legend: { position: 'bottom' },
                hAxis: {
                    title: 'Time'
                },
                vAxis: {
                    title: 'Gsensor'
                },
                chartArea: {
                    left: 60,
                    top: 20,
                    width: '85%',
                    height: '80%'
                },
                height: 300,
                backgroundColor: 'transparent',
                annotations: {
                    style: 'line'
                }
            },
            speedChartData: [],
            speedChartOptions: {
                legend: { position: 'bottom' },
                hAxis: {
                    title: 'Time'
                },
                vAxis: {
                    title: 'Speed'
                },
                chartArea: {
                    left: 60,
                    top: 20,
                    width: '75%',
                    height: '80%'
                },
                height: 300,
                backgroundColor: 'transparent',
                annotations: {
                    style: 'line'
                }
            },
            carMarker: '<svg xmlns="http://www.w3.org/2000/svg" width="31.809" height="40.521" viewBox="0 0 31.809 40.521"><path d="M26.871,4.267a15.764,15.764,0,0,0-11.79-4.2A15.94,15.94,0,0,0,0,15.965c0,11.47,11.2,21.341,14.578,24.129a2.122,2.122,0,0,0,1.325.457,2.034,2.034,0,0,0,1.325-.457A53.023,53.023,0,0,0,25.637,31.5c4.2-5.438,6.261-10.785,6.169-15.812A15.585,15.585,0,0,0,26.871,4.267Z" transform="translate(0 -0.03)" fill="#fff"/><path d="M18.664,41.074C16.151,39.063,5,29.375,5,18.818A13.605,13.605,0,0,1,17.887,5.2h.823A13.557,13.557,0,0,1,32.328,18.636C32.511,29.192,21.177,39.017,18.664,41.074Z" transform="translate(-2.715 -2.838)" fill="#aed51b"/><g transform="translate(6.079 11.699)"><g transform="translate(0 0)"><path d="M16.75,6.593l-2.872.287a.569.569,0,0,0-.479.574.562.562,0,0,0,.526.479h.048l2.872-.287a.569.569,0,0,0,.479-.574A.5.5,0,0,0,16.75,6.593Z" transform="translate(-6.986 -3.432)" fill="#fff"/><path d="M18.954,3.779l-3.685-.957a.978.978,0,0,1-.431-.239L12.54.62A2.7,2.7,0,0,0,11.1.045L7.514,0A4.3,4.3,0,0,0,3.877,1.768l-.622.862-1.532.191A2.062,2.062,0,0,0,0,4.879V6.411A1.473,1.473,0,0,0,1.532,7.895h.383A1.613,1.613,0,0,0,2.489,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.076,2.076,0,0,0,1.1.239,2.256,2.256,0,0,0,2.2-1.675h7.371A1.613,1.613,0,0,0,14.263,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.1,2.1,0,0,0,1.1.287,2.256,2.256,0,0,0,2.2-1.675c1.579-.048,2.345-.574,2.345-1.532v-.67A1.959,1.959,0,0,0,18.954,3.779ZM4.116,8.565A1.292,1.292,0,1,1,5.409,7.273,1.39,1.39,0,0,1,4.116,8.565Zm11.774,0a1.292,1.292,0,1,1,1.292-1.292A1.318,1.318,0,0,1,15.89,8.565Zm3.542-2.2c0,.383-.67.479-1.244.526a2.317,2.317,0,0,0-2.3-1.915,2.1,2.1,0,0,0-1.1.287.661.661,0,0,0-.191.144,2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H6.366a2.411,2.411,0,0,0-2.3-1.915,2.672,2.672,0,0,0-1.1.287c-.048,0-.1.048-.144.1a2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H1.532a.492.492,0,0,1-.526-.479V4.832a.986.986,0,0,1,.862-1.005L3.4,3.587a1.033,1.033,0,0,0,.67-.431l.574-.766A3.344,3.344,0,0,1,7.467,1l3.59.1a1.668,1.668,0,0,1,.814.287l2.25,1.962a2.43,2.43,0,0,0,.862.431l3.685.957a1.021,1.021,0,0,1,.766,1.005Z" transform="translate(0 0.005)" fill="#fff"/></g><path d="M1.54,4.62l1.771-.814,1.2-.479.862-.67,1.2-.766L8.528,1.7h2.824a3.981,3.981,0,0,1,1.388.191c.239.191.766.766.766.766l.814.814a6.083,6.083,0,0,0,1.053.622c.239.1,1.292.335,1.292.335l1.484.383,1.1.383,1.1.909s.144.862.144,1.149-.1.383-.574.574a5.572,5.572,0,0,1-.814.287L18.1,8.449l-.526.862-.766.574a4.4,4.4,0,0,1-.814,0,10.749,10.749,0,0,1-1.34-.718,1.5,1.5,0,0,0-.574-.622A6.883,6.883,0,0,0,12.548,8.4H10.107a10.12,10.12,0,0,0-1.723-.1c-.287.1-1.34.048-1.532.1a1.489,1.489,0,0,0-.526.048C6.278,8.5,5.7,9.6,5.7,9.6a2.579,2.579,0,0,1-.814.383c-.239,0-.718.1-.957-.1s-.67-.622-.67-.622A6.392,6.392,0,0,0,2.928,8.4a6.279,6.279,0,0,1-.718-.144c-.144-.048-.862-.239-.909-.383-.048-.1-.383-.526-.239-.718S1.061,5.1,1.54,4.62Z" transform="translate(-0.535 -0.884)" fill="#fff"/></g></svg>',
            vehicleInfoBubble: VehicleInfoBubble,
            isMap: false,
            isGSensorGraph: false,
            isSpeedingGraph: false
        }
    },
    computed: {
        eventTypes () {
            return this.sharedEvent.event.eventTypes.map(type => splitCamelCase(type)).join(', ')
        },
        eventCategories () {
            return this.sharedEvent.event.eventCategories.map(category => splitCamelCase(category)).join(', ')
        }
    },
    methods: {
        async getSharedEvent () {
            const response = await deviceEventSharedApi.getEventMediaByUri(this.uri)

            if (!response.isSuccess) {
                this.snapshotPackageNotFound = true
                this.isLoading = false
                return
            }

            this.sharedEvent = response.payload
        },
        async drawSpeedingChart () {
            if (0 === this.sharedEvent.event.speedPoints.length) {
                return
            }

            await google.charts.load('current', { packages: ['corechart'] })

            this.speedChartData = await new google.visualization.DataTable()
            this.speedChartData.addColumn('number', 'Time')
            this.speedChartData.addColumn({ type: 'string', role: 'annotation' })
            this.speedChartData.addColumn('number', 'Speed')
            this.sharedEvent.event.speedPoints.forEach((point, index) => {
                this.speedChartData.addRow([index, null, point])
            })
        },
        async drawGSensorChart () {
            if (0 === this.sharedEvent.event.gSensorFrames.length) {
                return
            }

            await google.charts.load('current', { packages: ['corechart'] })

            this.gSensorChartData = await new google.visualization.DataTable()
            this.gSensorChartData.addColumn('string', 'Time')
            this.gSensorChartData.addColumn({ type: 'string', role: 'annotation' })
            this.gSensorChartData.addColumn('number', 'X')
            this.gSensorChartData.addColumn('number', 'Y')
            this.gSensorChartData.addColumn('number', 'Z')

            this.sharedEvent.event.gSensorFrames.forEach((frame, index) => {
                const date = moment(frame.utc).format('YYYY-MM-DD HH:mm:ss').toString()

                this.gSensorChartData.addRow([date, null, frame.x, frame.y, frame.z])
            })
        },
        async drawCharts () {
            await this.drawSpeedingChart()
            await this.drawGSensorChart()

            this.isGSensorGraph = 0 !== this.sharedEvent.event.gSensorFrames.length
            this.isSpeedingGraph = 0 !== this.sharedEvent.event.speedPoints.length
            this.isMap = 0 < this.sharedEvent.event.locations.length && null != this.sharedEvent.event.locations[0]
        },
        dateFormat (date) {
            return formatDate(date)
        },
        updateFavicon () {
            const faviconImage = this.sharedEvent && this.sharedEvent.brand ? this.sharedEvent.brand.faviconUri : null
            const favicon = document.getElementById('favicon')
            if (faviconImage) {
                favicon.href = faviconImage
            } else {
                favicon.href = '/favicon.ico'
            }
        }
    }
}
</script>

<style scoped lang="scss">
#snapshot {
    min-height: 100vh;

    .header {
        height: 80px;
        background: #1D2A39;
        border-left: 16px solid #DB1238;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 288px;
            text-decoration: none;
            ::v-deep .dashboard {
                height: 100%;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-end;
                overflow: hidden;
                text-decoration: none;
                .powered-by {
                    text-align: end;
                }
            }

            @include breakpoint(md) {
                margin-left: 20px;
                margin-right: 20px;
                width: 100px;
            }
            img {
                display: flex;
                margin: 0;
                padding-left: 41px;
                max-height: 70%;
                width: auto;
                overflow: hidden;
                &.show-md {
                    display: none;

                    @include breakpoint(md) {
                        display: block;
                    }
                }

                &.show-lg {
                    display: none;

                    @include breakpoint(lg) {
                        display: block;
                    }
                }

            }
        }

        .login-button {
            padding-right: 41px;
        }
    }

    .view {
        padding-top: 50px;

        h1 {
            align-items: center;
            font-size: 30px;
            font-weight: 400;
            margin-bottom: 20px;
        }

        .top-box {
            display: flex;
        }

        .buttons {
            margin-left: auto;
        }

        .vehicle-info {
            height: 50px;
            background: #F5F5F5;
            padding: 0;
            font-size: 14px;
            font-weight: 400;
            display: flex;
            align-items: center;

            div {
                margin-right: 20px;
            }

            .icon {
                width: 50px;
                height: 50px;
                background-color: $secondary;
                background-repeat: no-repeat;
                background-position: center;

                &.video {
                    background-image: url('~@/assets/icons/icon-video-white.svg');
                }
            }
        }

        .content-box {
            padding: 24px 0;

            .table-box {
                height: calc(100% - 145px);

                tr {
                    cursor: pointer;

                    &.active,
                    &:hover {
                        background: $primary;

                        td {
                            color: $white;
                            font-weight: bold;
                        }
                    }
                }
            }

            .snapshot {
                margin-top: 5px;

                .box {
                    margin-bottom: 10px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .title {
                        background: $secondary;
                        color: $white;
                        height: 51px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 16px !important;
                        margin-bottom: 5px;
                        font-weight: 600;
                    }

                    .content {
                        background: $gray;
                        padding: 10px 20px;
                        font-size: 14px;

                        .layout {
                            padding: 5px 0;
                        }
                    }
                }

                .media {
                    .content {
                        height: 400px;

                        .image {
                            display: flex;
                            max-width: 100%;
                            height: 400px;
                            align-items: center;
                            margin: auto 0;
                            text-align: center;
                            background-size: contain;
                            background-position: center;
                        }

                        .no-media {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: 100%;
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}

.details,
.visualisation {
    > .flex {
        margin-bottom: 20px;
        padding: 0 5px;
    }

    .box,
    .media {
        .title {
            background: $secondary;
            color: $white;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px !important;
            margin-bottom: 5px;
        }
    }

    .box {
        display: flex;
        flex-flow: column;
        height: 100%;

        .content {
            background: $gray;
            padding: 10px 20px;
            font-size: 14px;
            height: calc(100% - 55px);

            .layout {
                padding: 5px 0;
            }
        }
    }

    .media {
        display: flex;
        flex-direction: column;
        height: 100%;
        margin-bottom: 20px;

        .content {
            height: calc(100% - 55px);
        }
    }

    .no-media {
        border: 1px solid #F5F5F5;
        padding: 99px 20px;
        text-align: center;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.google-event-map {
    width: 100%;
    height: 570px;
}

.v-card__title {
    height: 50px;
    background: $light-gray;
    padding: 0 15px;
    font-size: 14px;
    font-weight: 400;

    .reg-number, .make {
        margin-right: 20px;
    }
}

.v-tabs .v-window__container {
    height: auto !important;
}

.shared-event {
    &__info {
        margin-bottom: 50px;
        span {
            font-weight: 700;
        }
    }
    &__title {
        font-weight: 400;
    }
}
.media {
    .carousel-item-wrapper {
        padding-bottom: 50px;
        height: 100%;
        display: flex;
        justify-content: center;

        img {
            max-width: 100%;
            max-height: 100%;
        }
    }
    .one-item-carousel {
        ::v-deep .v-window-item {
            display: block!important;
        }
    }
    .many-media-items {
        ::v-deep .v-item-group {
            display: flex;
            gap: 15px;
            overflow-x: scroll;
            padding-left: 10px;
            padding-right: 10px;
        }
    }
}
</style>
